import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { topmenus } from "./../Data/routing";

import Error404 from "./../Pages/404/Error404";
import Faq from "./../Pages/FAQ/Faq";
import TermCondition from "./../Pages/TermCondition/TermCondition";
import Tree from "./../Pages/Tree/Tree";
import Carbon from "./../Pages/Carbon/Carbon";
import ForgotPassword from "./../Pages/ForgotPassword/ForgotPassword";
import SetPassword from "./../Pages/SetPassword/SetPassword";
import Login from "./../Pages/Login/Login";
import Logout from "./../Pages/Logout/Logout";
import Register from "./../Pages/Register/Register";
import CalculatorPage from "./../Pages/Calculator/CalculatorPage";
import Carts from "./../Pages/Cart/Carts";
import Checkout from "./../Pages/Checkout/Checkout";
import PaymentTree from "./../Pages/Payment/PaymentTree";
// import PaymentTreePublic from "./../Pages/Payment/PaymentTreePublic";
import PaymentCarbon from "./../Pages/Payment/PaymentCarbon";
// import PaymentSuccess from './../Pages/Payment/Success';
// import PaymentCancel from './../Pages/Payment/Cancel';
import ProgramDetailCarbon from "../Pages/Program/ProgramDetailCarbon";
import ProgramDetailTree from "../Pages/Program/ProgramDetailTree";
import Profile from "./../Pages/Profile/Profile";
import ChangePassword from "./../Pages/Profile/ChangePassword";
import TransactionsTree from "./../Pages/Transaction/TransactionsTree";
import TransactionsCarbon from "./../Pages/Transaction/TransactionsCarbon";
// import TransactionDetail from "./../Pages/Transaction/TransactionDetail";
// import Report from './../Pages/Report/Report';
import HeaderGeneral from "../Components/Header/HeaderGeneral";
// import Footer from "./../Components/Footer/Footer";
import OrderTreePublic from "../Pages/Payment/OrderTreePublic";

const LayoutGeneral = ({ children }) => (
  <div className="marketplace-app">
    <HeaderGeneral useSuspense={false} menus={topmenus} />
    {children}
    {/* <Footer /> */}
  </div>
);

export class Layout extends Component {
  render() {
    return (
      <div className="wrapper">
        <Router basename={process.env.PUBLIC_URL}>
          <Switch>
            <Route path="/" name="Calculator" component={CalculatorPage} exact />
            <Route path="/logout" name="Logout" component={Logout} exact />
            <Route path="/login" name="Login" component={Login} exact />
            <Route
              path="/register"
              name="Register"
              component={Register}
              exact
            />
            <Route
              path="/forgot"
              name="Forgot Password"
              // component={ForgotPassword}
              render={(routeProps) => (
                <ForgotPassword {...routeProps} useSuspense={false} />
              )}
              exact
            />
            <Route
              path="/new-password/:token"
              name="Set New Password"
              component={SetPassword}
              exact
            />
            <Route
              path="/order/tree/"
              name="Payment Tree"
              component={OrderTreePublic}
              exact
            />

            <LayoutGeneral>
              <Route path="/tree" component={Tree} exact />
              <Route path="/carbon" component={Carbon} exact />
              <Route path="/faq" component={Faq} exact />
              <Route path="/term-conditions" component={TermCondition} exact />
              <Route
                path="/program/carbon"
                name="Program Detail of Carbon"
                component={ProgramDetailCarbon}
                exact
              />
              <Route
                path="/program/tree"
                name="Program Detail of Tree"
                // component={ProgramDetailTree}
                render={(routeProps) => (
                  <ProgramDetailTree {...routeProps} useSuspense={false} />
                )}
                exact
              />
              <Route path="/cart" name="Cart" component={Carts} exact />
              <Route
                path="/checkout/:orderId/thanks"
                name="Checkout"
                component={Checkout}
                exact
              />

              <Route
                path="/payment/tree/status/:orderId"
                name="Payment Tree"
                // component={PaymentTree}
                render={(routeProps) => (
                  <PaymentTree {...routeProps} useSuspense={false} />
                )}
                exact
              />

              <Route
                path="/payment/carbon/status/:orderId"
                name="Payment Carbon"
                component={PaymentCarbon}
                exact
              />

              <Route
                path="/profile"
                name="Profile"
                // component={Profile}
                render={(routeProps) => (
                  <Profile {...routeProps} useSuspense={false} />
                )}
                exact
              />
              <Route
                path="/change-password"
                name="Change Password"
                // component={ChangePassword}
                render={(routeProps) => (
                  <ChangePassword {...routeProps} useSuspense={false} />
                )}
                exact
              />
              <Route
                path="/transaction/tree"
                name="Transaction of Tree"
                // component={TransactionsTree}
                render={(routeProps) => (
                  <TransactionsTree {...routeProps} useSuspense={false} />
                )}
                exact
              />
              <Route
                path="/transaction/carbon"
                name="Transaction of Carbon"
                component={TransactionsCarbon}
                exact
              />
            </LayoutGeneral>

            <Route component={Error404} />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default Layout;
